module.exports = __webpack_public_path__ + "static/44424-79cd8848885d06ea10d1c206e8f34d9c.jpg";